import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgIvermectinGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "m17.898 16.052-1.067.612 3.136 5.462 1.067-.613-3.136-5.461ZM24.125 19.737l-.84-4.779-1.1.63.62 2.87.12.389-.28-.3-2.159-1.98-1.1.63 3.71 3.13 1.029-.59Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m31.643 9-15.995.41L8 23.465l8.357 13.656 15.995-.41L40 22.656 31.643 9Zm-.04 26.482-14.566.37L9.44 23.426l6.957-12.786 14.556-.37 7.598 12.416-6.948 12.796Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "m30.593 21.976-1.46-2.97-1.71 2.83-2.968 1.46 2.829 1.709 1.46 2.969 1.709-2.83 2.969-1.459-2.83-1.71Zm-1.02 2.21-.72 1.179-.61-1.24-1.179-.72 1.24-.61.72-1.179.61 1.24 1.189.72-1.25.61ZM22.236 27.584l-2.12-1.33.03 2.5-1.33 2.12 2.5-.03 2.12 1.329-.03-2.5 1.329-2.119-2.5.03Zm-.07 2.33-.5-.31-.59.01.31-.5-.01-.59.5.31.59-.01-.31.5.01.59Z",
    fill: "currentColor"
  }));
}

export { SvgIvermectinGlyph as default };
